<template>
    <div class="v-client">
        <Header></Header>
        <Navigation></Navigation>
        <div class="v-client__content container">
            <div class="flex-row">
                <div class="flex-col">
                    <clientFooter></clientFooter>
                </div>
                <div class="flex-col flex-col--4 ml--3">
                <Summary></Summary>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>
<script>

    import Footer from '@/components/footer.vue'
    import Header from '@/components/header.vue'
    import Navigation from "@/components/navigation";

    import Summary from "@/components/services/summary";
    import clientFooter from "@/components/client/form";

    export default {
        components:{
            Footer,
            Header,
            Navigation,
            Summary,
            clientFooter
        }
    }

</script>
<style lang="scss">
    .v-client{
        &__content{
            min-height: 90vh;
        }
    }
</style>